import State from "./state";
import FootballState from "./football-state";

const states = {
    [FootballState.SkipKickoff]: new State(
        FootballState.SkipKickoff,
        "Forego Kickoff"
    ),
    [FootballState.Start]: new State(FootballState.Start, "Start", {
        navigable: false
    }),
    [FootballState.AddPlay]: new State(FootballState.AddPlay, "Add play", {
        navigable: false
    }),
    [FootballState.KneelDown]: new State(FootballState.KneelDown, "Kneel Down"),
    // Fumbled Snap
    [FootballState.FumbledSnap]: new State(
        FootballState.FumbledSnap,
        "Fumbled Snap"
    ),
    [FootballState.FumbledSnapLost]: new State(
        FootballState.FumbledSnapLost,
        "Lost"
    ),
    [FootballState.FumbledSnapRecovered]: new State(
        FootballState.FumbledSnapRecovered,
        "Recovered"
    ),
    [FootballState.DeadBall]: new State(FootballState.DeadBall, "Dead Ball"),
    [FootballState.Rush]: new State(FootballState.Rush, "Rush"),
    [FootballState.EndOfPlay]: new State(
        FootballState.EndOfPlay,
        "End of play"
    ),
    [FootballState.NoPenaltyEndOfPlay]: new State(
        FootballState.NoPenaltyEndOfPlay,
        "End of play"
    ),
    [FootballState.OutOfBounds]: new State(
        FootballState.OutOfBounds,
        "Out of bounds"
    ),
    [FootballState.Muffed]: new State(FootballState.Muffed, "Muffed"),
    [FootballState.Safety]: new State(FootballState.Safety, "Safety"),
    [FootballState.Fumble]: new State(FootballState.Fumble, "Fumble"),
    [FootballState.FumbleRecovered]: new State(
        FootballState.FumbleRecovered,
        "Fumble Recovered"
    ),
    [FootballState.FumbleNotRecovered]: new State(
        FootballState.FumbleNotRecovered,
        "Fumble Not Recovered"
    ),
    [FootballState.Tackle]: new State(FootballState.Tackle, "Tackle"),
    [FootballState.PatTry]: new State(FootballState.PatTry, "PAT Try"),
    [FootballState.PatKick]: new State(FootballState.PatKick, "Kick"),
    [FootballState.PatReturned]: new State(
        FootballState.PatReturned,
        "Returned"
    ),
    [FootballState.PatContinued]: new State(
        FootballState.PatContinued,
        "Continued"
    ),
    [FootballState.PatRecovered]: new State(
        FootballState.PatRecovered,
        "Recovered"
    ),
    [FootballState.PatNotRecovered]: new State(
        FootballState.PatNotRecovered,
        "Not Recovered"
    ),
    [FootballState.PatPointsNotAwarded]: new State(
        FootballState.PatPointsNotAwarded,
        "Points Not Awarded"
    ),
    [FootballState.PatPointsAwarded]: new State(
        FootballState.PatPointsAwarded,
        "Points Awarded"
    ),
    [FootballState.Finalize]: new State(FootballState.Finalize, "Finalize"),
    [FootballState.Kick]: new State(FootballState.Kick, "Kick"),
    [FootballState.CflKick]: new State(FootballState.CflKick, "Kick"),
    [FootballState.KickOff]: new State(FootballState.KickOff, "Kick Off"),
    // Deuce (Indoor Football - kickoff through uprights)
    [FootballState.Deuce]: new State(FootballState.Deuce, "Deuce"),
    [FootballState.DeuceGood]: new State(FootballState.DeuceGood, "Deuce Good"),
    [FootballState.DeuceMissed]: new State(
        FootballState.DeuceMissed,
        "Deuce Missed"
    ),
    // Rebound Net (Indoor Football - ball hits net and stays live)
    [FootballState.HitReboundNet]: new State(
        FootballState.HitReboundNet,
        "Hit Rebound Net"
    ),
    [FootballState.ReboundNetCaughtOffense]: new State(
        FootballState.ReboundNetCaughtOffense,
        "Caught by Offense"
    ),
    [FootballState.ReboundNetCaughtDefense]: new State(
        FootballState.ReboundNetCaughtDefense,
        "Intercepted"
    ),
    [FootballState.ReboundNetHitGround]: new State(
        FootballState.ReboundNetHitGround,
        "Hit Ground"
    ),
    [FootballState.ReboundNetFieldedKicking]: new State(
        FootballState.ReboundNetFieldedKicking,
        "Fielded by Kicking"
    ),
    [FootballState.ReboundNetFieldedReceiving]: new State(
        FootballState.ReboundNetFieldedReceiving,
        "Fielded by Receiving"
    ),
    // Bar Ball (Indoor Football - kickoff hits goalpost)
    [FootballState.HitGoalpost]: new State(
        FootballState.HitGoalpost,
        "Hit Goalpost"
    ),
    [FootballState.BarBallRecoveredKicking]: new State(
        FootballState.BarBallRecoveredKicking,
        "Recovered by Kicking"
    ),
    [FootballState.BarBallRecoveredReceiving]: new State(
        FootballState.BarBallRecoveredReceiving,
        "Recovered by Receiving"
    ),
    [FootballState.NoRecoveryKickReturn]: new State(
        FootballState.NoRecoveryKickReturn,
        "Returned"
    ),
    [FootballState.FieldGoal]: new State(FootballState.FieldGoal, "Field Goal"),
    [FootballState.FieldGoalFumble]: new State(
        FootballState.FieldGoalFumble,
        "Fumble"
    ),
    [FootballState.FieldGoalFakeRun]: new State(
        FootballState.FieldGoalFakeRun,
        "Fake Run"
    ),
    [FootballState.FieldGoalFakePass]: new State(
        FootballState.FieldGoalFakePass,
        "Fake Pass"
    ),
    [FootballState.FieldGoalGood]: new State(
        FootballState.FieldGoalGood,
        "Good"
    ),
    [FootballState.FieldGoalMissed]: new State(
        FootballState.FieldGoalMissed,
        "Missed"
    ),
    [FootballState.FieldGoalBlocked]: new State(
        FootballState.FieldGoalBlocked,
        "Blocked"
    ),
    [FootballState.KickOffPenalty]: new State(
        FootballState.KickOffPenalty,
        "Kick Off Penalty"
    ),
    [FootballState.KickOffPenaltyAccepted]: new State(
        FootballState.KickOffPenaltyAccepted,
        "Kick Off Penalty Accepted"
    ),
    [FootballState.KickOffPenaltyDeclined]: new State(
        FootballState.KickOffPenaltyDeclined,
        "Kick Off Penalty Declined"
    ),
    [FootballState.Rouge]: new State(FootballState.Rouge, "Rouge"),
    [FootballState.Downed]: new State(FootballState.Downed, "Downed"),
    [FootballState.TouchBack]: new State(FootballState.TouchBack, "Touchback"),
    [FootballState.FairCatch]: new State(FootballState.FairCatch, "Fair Catch"),
    [FootballState.KickRecovered]: new State(
        FootballState.KickRecovered,
        "Recovered"
    ),
    [FootballState.KickNotRecovered]: new State(
        FootballState.KickNotRecovered,
        "Not Recovered"
    ),
    [FootballState.OnSide]: new State(FootballState.OnSide, "On Side"),
    [FootballState.Punt]: new State(FootballState.Punt, "Punt"),
    [FootballState.PuntBlocked]: new State(
        FootballState.PuntBlocked,
        "Blocked"
    ),
    [FootballState.PuntOutOfBounds]: new State(
        FootballState.PuntOutOfBounds,
        "Out of bounds"
    ),
    [FootballState.FieldGoalOutOfBounds]: new State(
        FootballState.FieldGoalOutOfBounds,
        "Out of bounds"
    ),
    [FootballState.Continue]: new State(FootballState.Continue, "Continue"),
    [FootballState.Returned]: new State(FootballState.Returned, "Returned"),
    //PASS
    [FootballState.Pass]: new State(FootballState.Pass, "Pass"),
    [FootballState.PassIntercepted]: new State(
        FootballState.PassIntercepted,
        "Intercepted"
    ),
    [FootballState.PassComplete]: new State(
        FootballState.PassComplete,
        "Reception"
    ),
    [FootballState.PassIncomplete]: new State(
        FootballState.PassIncomplete,
        "Incomplete"
    ),
    [FootballState.PassBrokenUp]: new State(
        FootballState.PassBrokenUp,
        "Broken Up"
    ),
    [FootballState.PassDropped]: new State(
        FootballState.PassDropped,
        "Dropped"
    ),
    [FootballState.PassSacked]: new State(FootballState.PassSacked, "Sacked"),
    [FootballState.DropKick]: new State(FootballState.DropKick, "Drop kick"),
    [FootballState.PatBlocked]: new State(
        FootballState.PatBlocked,
        "Pat Blocked"
    ),
    [FootballState.PatCompleted]: new State(
        FootballState.PatCompleted,
        "Pat Completed"
    ),
    [FootballState.PatMissed]: new State(FootballState.PatMissed, "Pat Missed"),
    [FootballState.PatFumbled]: new State(
        FootballState.PatFumbled,
        "Pat Fumbled"
    ),
    [FootballState.PatPass]: new State(FootballState.PatPass, "Pat Pass"),
    [FootballState.PatIntercepted]: new State(
        FootballState.PatIntercepted,
        "Pat Intercepted"
    ),
    [FootballState.Run]: new State(FootballState.Run, "Rush"),
    [FootballState.GameControl]: new State(
        FootballState.GameControl,
        "Game Control"
    ),
    [FootballState.StartDrive]: new State(
        FootballState.StartDrive,
        "Start Drive"
    ),
    [FootballState.GameStart]: new State(FootballState.GameStart, "Game Start"),
    [FootballState.Timeout]: new State(FootballState.Timeout, "Timeout"),
    [FootballState.UpdateContext]: new State(
        FootballState.UpdateContext,
        "Update Field"
    ),
    [FootballState.SwapTeams]: new State(FootballState.SwapTeams, "Swap Teams"),
    // Penalties
    [FootballState.Penalty]: new State(FootballState.Penalty, "Penalty"),
    [FootballState.SecondPenalty]: new State(
        FootballState.SecondPenalty,
        "Penalty"
    ),
    [FootballState.PenaltyDeclined]: new State(
        FootballState.PenaltyDeclined,
        "Penalty declined"
    ),
    [FootballState.PenaltyAccepted]: new State(
        FootballState.PenaltyAccepted,
        "Penalty accepted"
    ),
    [FootballState.Offsetting]: new State(
        FootballState.Offsetting,
        "Offsetting"
    ),
    [FootballState.SecondOffsetting]: new State(
        FootballState.SecondOffsetting,
        "Offsetting"
    ),
    [FootballState.StatsCount]: new State(
        FootballState.StatsCount,
        "Stats Count"
    ),
    [FootballState.NoPlay]: new State(FootballState.NoPlay, "No Play"),
    // Play Penalties
    [FootballState.PlayPenalty]: new State(
        FootballState.PlayPenalty,
        "Penalty"
    ),
    [FootballState.PlayPenaltySecondPenalty]: new State(
        FootballState.PlayPenaltySecondPenalty,
        "Penalty"
    ),
    [FootballState.PlayPenaltyPenaltyDeclined]: new State(
        FootballState.PlayPenaltyPenaltyDeclined,
        "Penalty declined"
    ),
    [FootballState.PlayPenaltyPenaltyAccepted]: new State(
        FootballState.PlayPenaltyPenaltyAccepted,
        "Penalty accepted"
    ),
    [FootballState.PlayPenaltyOffsetting]: new State(
        FootballState.PlayPenaltyOffsetting,
        "Offsetting"
    ),
    [FootballState.PlayPenaltySecondOffsetting]: new State(
        FootballState.PlayPenaltySecondOffsetting,
        "Offsetting"
    ),
    [FootballState.PlayPenaltyNoPlay]: new State(
        FootballState.PlayPenaltyNoPlay,
        "No Play"
    ),
    [FootballState.PlayPenaltyStatsCount]: new State(
        FootballState.PlayPenaltyStatsCount,
        "Stats Count"
    ),
    [FootballState.Spike]: new State(FootballState.Spike, "Spike"),
    [FootballState.StartPeriod]: new State(
        FootballState.StartPeriod,
        "Start period"
    ),
    [FootballState.CoinToss]: new State(FootballState.CoinToss, "Coin toss"),
    [FootballState.Lateral]: new State(FootballState.Lateral, "Lateral"),
    [FootballState.SetTimeAndPeriod]: new State(
        FootballState.SetTimeAndPeriod,
        "Set time and period"
    )
};

export default class StateBuilder {
    static build(state) {
        return states[state] || new State(state, state);
    }

    static getByName(state) {
        return states[state];
    }
}
